import { parseISO, format } from 'date-fns';

const getDay = (dateISOString: string) => {
  const parsedDate = parseISO(dateISOString);

  return format(parsedDate, 'd');
};

export default getDay;
